import React from 'react';
import { TXUserEditForm } from '../TXUserEditForm';
import { TXUserCreateForm } from '../TXUserCreateForm/TXUserCreateForm';
import { TXUserDetailsSection } from './components/TXUserDetailsSection';

export type TXUserFormProps = {
  isReadOnly?: boolean;
  isEditMode: boolean;
};

export const TXUsersForm = React.memo(({ isReadOnly = false, isEditMode }: TXUserFormProps) => {
  return (
    <>
      <TXUserDetailsSection isReadOnly={isReadOnly} isEditMode={isEditMode} />
      {isEditMode ? <TXUserEditForm /> : <TXUserCreateForm />}
    </>
  );
});

TXUsersForm.displayName = 'TXUsersForm';
